
import React from 'react';

interface TrustIndicatorProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  iconBgClass: string;
  iconClass: string;
}

const TrustIndicator = ({ icon, title, description, iconBgClass, iconClass }: TrustIndicatorProps) => {
  return (
    <div className="flex flex-col items-center text-center">
      <div className={`w-16 h-16 rounded-full ${iconBgClass} flex items-center justify-center mb-4`}>
        {React.cloneElement(icon as React.ReactElement, { className: iconClass })}
      </div>
      <h4 className="text-xl font-semibold mb-2">{title}</h4>
      <p className="text-muted-foreground">{description}</p>
    </div>
  );
};

export default TrustIndicator;
